import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'TaxationRegime';
const ENDPOINT = `/taxation-regimes/`;

@Injectable({
    providedIn: 'root'
})
export class TaxationRegimeService extends ServiceBase {

    protected override useCache = true;

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
